import Api,{ HttpResponse, Result } from './../utils/request';


class SettingService{

    static async SetWmAsync(parameters:any):Promise<HttpResponse>{
        let msg = parameters
        return Api.Post("travel_set_wm",msg)
    }

    static async GetWmAsync():Promise<HttpResponse>{
        let msg = {}
        return Api.Post("travel_get_wm",msg)
    }
}
export default SettingService;